export const SET_BREADCRUMB_MAPPER = 'SET_BREADCRUMB_MAPPER'
